//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/TaggedObject.js";
import "../no/PartLoadStatus.js";
let d=[[],[[["workpartName"],"InitHybridWorkerForTest",{},1,0],[["filename","load_status"],"OpenBaseDisplayTest",{R_:{part:"BasePart"}},1,0],[[],"CreateTransaction",{R_:{transactionId:''}},0,0],[["transactionId"],"SaveToTCX",{},1,0]],[]];
SPLM.HybridTest = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.HybridTest";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;